import { sendGetRequest, sendPostRequest } from './utils.js';

let unreadTargetIds = [];
let pingsFetched = false;

async function fetchUnreadPings() {
    try {
        const response = await sendGetRequest(
            '/api/notifications/unread_pings/',
        );
        unreadTargetIds = await response.json();
    } catch (e) {
        console.error('Failed to fetch unread pings:', e);
    }
}

function isPingSeen(updateKey) {
    return !unreadTargetIds.includes(updateKey);
}

function areAllWindowsPingsSeen(windowElement) {
    const nestedPingButtons = windowElement.querySelectorAll('.ping-button');
    if (nestedPingButtons.length === 0) return true;

    for (const nestedButton of nestedPingButtons) {
        const nestedUpdateKey = nestedButton.dataset.updateKey;

        if (!isPingSeen(nestedUpdateKey)) {
            return false;
        }
    }
    return true;
}

function initializeWindowsPingsSeen(windowElement, id) {
    if (!id) return;
    const nestedPingButtons = windowElement.querySelectorAll('.ping-button');
    if (nestedPingButtons.length === 0) return true;

    for (const nestedButton of nestedPingButtons) {
        nestedButton.dataset.pingParent = id;
    }
}

function showHidePing(pingElement, showPing) {
    if (showPing) {
        pingElement.classList.remove('hidden');
    } else {
        pingElement.classList.add('hidden');
    }
}

export function updatePing(button) {
    if (!button) return;
    const updateKey = button.dataset.updateKey;
    const pingElement = button.querySelector('.ping');
    const windowId = button.dataset.window;
    const windowElement = windowId ? document.getElementById(windowId) : null;

    if (!updateKey || !pingElement) {
        return;
    }

    let show = !isPingSeen(updateKey);

    if (windowElement && !show) {
        const nestedPingsSeen = areAllWindowsPingsSeen(windowElement);
        show = !nestedPingsSeen;
    }

    showHidePing(pingElement, show);
}

export async function handlePingSeen(button) {
    const updateKey = button.dataset.updateKey;

    try {
        await sendPostRequest('/api/notifications/mark_target_read/', {
            target_id: updateKey,
        });

        unreadTargetIds = unreadTargetIds.filter((id) => id !== updateKey);

        document.querySelectorAll('.ping-button').forEach((btn) => {
            updatePing(btn);
        });
    } catch (e) {
        console.error('Failed to mark ping as read:', e);
    }
}

export async function updateAllPingsOnPage() {
    await fetchUnreadPings();
    document.querySelectorAll('.ping-button').forEach((btn) => {
        updatePing(btn);
    });
}

document.addEventListener('pingSeen', () => {
    updateAllPingsOnPage();
});

export async function initializePings(container) {
    if (unreadTargetIds.length === 0 && !pingsFetched) {
        pingsFetched = true;
        await fetchUnreadPings();
    }

    const pingButtons = container.querySelectorAll('.ping-button');
    pingButtons.forEach(async (button) => {
        const updateKey = button.dataset.updateKey;
        const pingElement = button.querySelector('.ping');
        const windowId = button.dataset.window;
        const windowElement = windowId
            ? document.getElementById(windowId)
            : null;

        if (!updateKey || !pingElement) {
            console.warn(
                'Ping button missing data-update-key or .ping element:',
                button,
            );
            return;
        }

        updatePing(button);

        if (windowElement) {
            await new Promise((r) => setTimeout(r, 1000));
            initializeWindowsPingsSeen(windowElement, button.id);
            updatePing(button);
        }

        button.addEventListener('click', () => {
            handlePingSeen(button);
        });
    });
}
